import { Medal, ShieldCheck, ShieldStar, Truck } from "@phosphor-icons/react";
import { media } from "@/data/siteContent";

const stats = [
  { id: "experience", value: 20, suffix: "+", label: "Yıllık tecrübe", icon: Medal },
  { id: "moves", value: 5000, suffix: "+", label: "Tamamlanan taşınma", icon: Truck },
  { id: "teams", value: 12, suffix: "+", label: "Profesyonel ekipman", icon: ShieldStar },
  { id: "families", value: 98, suffix: "%", label: "Memnuniyet odağı", icon: ShieldCheck },
];

export default function AboutSection() {
  return (
    <section id="hakkimizda" data-testid="about-section" className="relative overflow-hidden bg-[#0A0A0B] px-6 py-24 lg:px-8 lg:py-32">
      <div data-testid="about-parallax-background" data-parallax-speed="0.5" className="absolute -inset-y-20 inset-x-0 opacity-30 will-change-transform">
        <img data-testid="about-background-image" src={media.elevator} alt="Has Kırıkhan Nakliyat Hatay asansörlü nakliyat ekipmanı" loading="lazy" className="h-full w-full object-cover object-center" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/65" />
      <div className="relative mx-auto grid max-w-7xl gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:items-center">
        <div data-testid="about-copy" className="max-w-2xl">
          <p data-testid="about-overline" className="text-xs font-black uppercase tracking-[0.22em] text-orange-500">Hakkımızda</p>
          <h2 data-testid="about-title" className="mt-4 font-heading text-3xl font-black tracking-tight text-white sm:text-4xl">Kırıkhan’dan çıkan güçlü, planlı ve güvenilir nakliyat ekibi.</h2>
          <p data-testid="about-description" className="mt-5 text-base leading-relaxed text-slate-300 md:text-lg">
            Has Kırıkhan Nakliyat; ev, ofis, şehirler arası ve asansörlü taşıma süreçlerinde hızlı keşif, doğru ekipman ve temiz çalışma prensibiyle hareket eder.
          </p>
        </div>

        <div data-testid="about-stats-grid" data-stagger-group="about-stats" className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {stats.map((stat) => {
            const Icon = stat.icon;
            return (
              <article key={stat.id} data-stagger-item="about-stat" data-testid={`about-stat-${stat.id}`} className="rounded-3xl border border-white/10 bg-[#121214]/95 p-6 shadow-2xl transition-[transform,border-color,background-color] duration-300 hover:-translate-y-1 hover:border-orange-500/60 hover:bg-[#1A1A1E]">
                <Icon data-testid={`about-stat-icon-${stat.id}`} size={34} weight="duotone" className="text-orange-500" />
                <div data-testid={`about-stat-value-${stat.id}`} data-count-to={stat.value} data-count-suffix={stat.suffix} className="mt-5 font-heading text-4xl font-black tracking-tight text-white">0{stat.suffix}</div>
                <p data-testid={`about-stat-label-${stat.id}`} className="mt-2 text-sm font-semibold text-slate-400">{stat.label}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}